<!-- <div class="loginWraper">
  <div class="loginLft animated fadeIn">
    <div class="loginTag">One Framework<br> <span>Mobile &amp; Desktop</span></div>
  </div>
  <div class="loginRgt animated fadeInRight">
    <div class="dTable h-100 w-100">
      <div class="dTableCell h-100 align-middle"> -->
        <!-- <p-growl [(value)]="msgs"></p-growl> -->
        <router-outlet></router-outlet>
      <!-- </div>
    </div>
  </div>
</div> -->
